import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import {TranslationProvider} from "./context/translationContext";
import LocationApp from "./apps/LocationApp";
import {Mode} from "./enum/mode";

const roots : HTMLCollectionOf<Element> = document.getElementsByClassName('nezzosohlocation_location');

[].forEach.call(roots, function(root: HTMLElement) {

    const translationScriptTag = document.getElementById('nezzosohlocation_translation');
    const translations = JSON.parse(translationScriptTag ? translationScriptTag.innerHTML : '[]');

    const api = root.getAttribute('data-api');
    const categories = root.getAttribute('data-categories');
    const mode: Mode = root.getAttribute('data-mode') as Mode;

    if(api && categories && mode) {
        ReactDOM.render(
            <TranslationProvider value={translations}>
                <LocationApp
                    api={api}
                    categories={JSON.parse(categories)}
                    mode={mode}
                />
            </TranslationProvider>,
            root
        );
    }

});
